import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "info-item-bottom" }
const _hoisted_2 = { class: "info-item-bottom font-weight600" }
const _hoisted_3 = { class: "info-item-bottom" }
const _hoisted_4 = { class: "info-item-bottom font-weight600" }
const _hoisted_5 = { class: "info-item-bottom" }
const _hoisted_6 = { class: "info-item-bottom font-weight600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_dialog_shell, {
      footerType: "customize",
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
      title: _ctx.$wordList.TabelVersionTitleDetail
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootCancel), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("p", _hoisted_2, _toDisplayString(_ctx.$wordList.TabelUpdateBoxVersion), 1),
          _createVNode("p", null, "-" + _toDisplayString(_ctx.initForm.Version), 1)
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$wordList.TabelVersionModel), 1),
          _createVNode("p", null, "-" + _toDisplayString(_ctx.initForm.Model), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("p", _hoisted_6, _toDisplayString(_ctx.$wordList.TabelVersionLog), 1),
          _createVNode("p", null, _toDisplayString(_ctx.initForm.Log), 1)
        ])
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}